module.exports = __webpack_public_path__ + "static/img/pic_17@2x.90738114.png";